export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Użytkownik nie znaleziony"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wybierz"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zamknij"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Szukaj"])}
}